/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultTemplateChat } from '../../models/api-response-paged-result-template-chat';
import { PagedRequestTemplateChat } from '../../models/paged-request-template-chat';

export interface SearchTemplates$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestTemplateChat
}

export function searchTemplates(http: HttpClient, rootUrl: string, params: SearchTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateChat>> {
  const rb = new RequestBuilder(rootUrl, searchTemplates.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultTemplateChat>;
    })
  );
}

searchTemplates.PATH = '/v1/api/ui/templates-chat/search';
